import { initialState } from './selectors';
import {
  ADD_TRANSLATIONS,
  CHANGE_LANGUAGE,
  ADD_LANGUAGES,
} from './actions';

export default (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        lang: payload.language,
      };
    case ADD_TRANSLATIONS:
      return {
        ...state,
        translations: {
          ...state.translations,
          [payload.language]: payload.translations,
        },
      };
    case ADD_LANGUAGES:
      return {
        ...state,
        languages: payload.languages,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/lang/reducer.js